<script lang="ts">
	/**
	 * The page router is simply for breaking up the unprotected routes (e.g., login from the protected routes (all of the others))
	 */

	// Some evil package updates made the svelte component type break, which results in errors on the component prop - ignore this as this is just a typescript issue.

	import { navigate, Route, Router } from "svelte-routing"

	import ProtectedRoute from "../reusable/auth/ProtectedRoute.svelte"
	import Login from "./login/Login.svelte"
	import AppRouter from "./AppRouter.svelte"
	import PasswordReset from "./login/RequestPasswordReset.svelte"
	import { onMount } from "svelte"
	import WifiHelp from "./wifi-help/WifiHelp.svelte"
	import PortalMoved from "./moved/PortalMoved.svelte"
	import { isLegacyPortalHost } from "../../modules/legacy-domain"
	import { NEXT_ROUTE_KEY } from "./Routes"

	const MOVED_PATH = "/we-moved"

	onMount(() => {
		if (window.location.hostname === "connect.luxedo.com") return navigate("/wifi-help")

		// Legacy myluxedo.com hosts: send everyone to the "we've moved" notice.
		// Captured here at app start, so pathname is still the URL the user
		// actually asked for — forwarded as `next` so the notice can deep-link
		// them to the same place on the new domain.
		if (isLegacyPortalHost() && window.location.pathname !== MOVED_PATH) {
			const from = `${window.location.pathname}${window.location.search}`
			const carry =
				from && from !== "/" ? `?${NEXT_ROUTE_KEY}=${encodeURIComponent(from)}` : ""
			navigate(`${MOVED_PATH}${carry}`, { replace: true })
		}
	})
</script>

<Router>
	<Route path="login">
		<Login />
	</Route>
	<Route path="we-moved">
		<PortalMoved />
	</Route>
	<Route path="wifi-help">
		<WifiHelp />
	</Route>
	<Route path="password-reset">
		<PasswordReset />
	</Route>

	<ProtectedRoute path="*" component={AppRouter} />
</Router>

<style>
</style>
